import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateTagsManagerGrid = document.createElement('template');

templateTagsManagerGrid.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
     <header class="page__header">
      <gz-title id="page-title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
      </header>

      <gz-grid-view>
        <div class="header__actions" slot="grid-header-actions-slot">
          <gz-button id="add-tag-button" class="mr-2" data-add-tag></gz-button>
          <gz-button id="delete-tags-button" type="outline" color="negative" class="mr-2" data-delete-tags disabled></gz-button>
        </div>

        <div slot="no-results--additional-data">
          <gz-text id="tags-empty-state-text" fontSize="14"></gz-text>
        </div>
      </gz-grid-view>
  </div>
`;
